import Image from "../common/Image";
import logoImg from "../../assets/images/Logo-light.png";
import uklogo from "../../assets/images/UK-logo.png";
import AuthHeading from "../Auth/AuthHeading";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const AuthLayout = ({ children, title, showLanguageToggle = false }) => {
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();

  return (
    <div className="w-full min-h-screen bg-gray-100 relative">
      {showLanguageToggle && (
        <div className="absolute top-4 right-6 flex items-center gap-2 z-20">
          <span className="text-sm text-gray-700">English</span>

          <button
            type="button"
            onClick={() => setLanguage(!language)}
            className={`relative inline-flex h-5 w-10 items-center rounded-full bg-gray-300  ${language ? "bg-btn" : "bg-gray-300"}`}
          >
            <span
              className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform
              ${language ? "translate-x-6" : "translate-x-1"}`}
            />
          </button>

          <span className="text-sm text-gray-700">हिंदी</span>
        </div>
      )}

      <div className="flex min-h-screen">
        <div className="hidden md:flex w-full md:w-1/2 text-white items-center justify-center px-5 left-side">
          <div className="relative z-10 flex flex-col items-center text-center">
            <Image
              src={logoImg}
              alt="Logo"
              className="mb-4 w-1/4 cursor-pointer"
              onClick={() => navigate("/", { replace: true })}
            />
            <h1 className="text-3xl font-semibold text-white">
              {language ? "इन्वेस्ट उत्तराखंड" : "Invest Uttarakhand"}
            </h1>
          </div>
        </div>

        <div className="w-full md:w-1/2 flex items-center justify-center bg-light p-6">
          <div className="w-full max-w-lg bg-white border border-gray-300 rounded-lg shadow-lg p-10 space-y-6">
            <div className="text-center md:hidden">
              <Image src={uklogo} alt="Logo" className="mx-auto w-1/2 mb-4" />
            </div>
            {title && <AuthHeading title={title} />}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
